import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { EcoChallengeModel } from '../models/eco-challenge.model';

export class EcoChallengeApiService extends ApiService {
  static endpoint = 'eco-challenge';

  /**
   * @param {string | number} id
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async get(id, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(id), {
      ...config,
      dataModel: EcoChallengeModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<EcoChallengeModel>>}
   * @public
   */
  static async getAll(builderCallback = null, config = {}, ) {
    return HttpApiClient.get(this.buildUrl(),{
      ...config,
      dataModel: EcoChallengeModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} order
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<EcoChallengeModel>>}
   * @public
   */
  static async post(order, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(order), data, {
      ...config,
      dataModel: EcoChallengeModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
